/* BECAY - carrusel de las product cards.
   Antes: un script inline duplicado por cada tarjeta y TODOS los Swipers
   inicializandose a la vez en DOMContentLoaded (rafaga de trabajo justo al
   volverse interactiva la pagina). Ahora: una sola copia cacheable; cada
   swiper se inicializa de forma perezosa cuando su tarjeta se acerca al
   viewport, en lugar de todos a la vez en DOMContentLoaded.
   Se inicializan EXACTAMENTE las mismas tarjetas que antes: las del HTML
   servido. Las que llegan por AJAX (recomendados, vistos recientemente,
   filtros de coleccion) NO llevan swiper propio, igual que siempre: el
   <script> inline que tenian dentro nunca se ejecutaba al inyectarse, y
   darles uno rompia el arrastre del <scroll-carousel> que las envuelve
   (los dos gestos se peleaban). Ver la nota del 2026-09-04 en CLAUDE.md.
   La logica por tarjeta replica la original: init con loop, boton visible
   tras init, y en desktop se quita la 2a slide (imagen hover) del track.
   Ademas se le pasa a Swiper el ancho REAL de la tarjeta (ver cardWidth):
   es lo que quita la franja del borde izquierdo. */
(function () {
  'use strict';

  var cards = [];
  var isDesktop = window.innerWidth >= 758;

  function removeSecondSlide(entry) {
    var second = entry.el.querySelector('.swiper-slide:nth-child(2)');
    if (second) {
      entry.removedSlide = second.cloneNode(true);
      second.remove();
    }
  }

  function restoreSecondSlide(entry) {
    if (!entry.removedSlide) return;
    var first = entry.el.querySelector('.swiper-slide:nth-child(1)');
    if (first) {
      first.insertAdjacentElement('afterend', entry.removedSlide);
      entry.removedSlide = null;
    }
  }

  function slideCount(el) {
    return el.querySelectorAll('.swiper-wrapper > .swiper-slide').length;
  }

  /* Ancho REAL (fraccionario) de la tarjeta. Swiper mide con clientWidth, que
     es entero: en una rejilla fluida la tarjeta mide 187,33 px, Swiper cree
     187, y ese tercio de pixel (sumado al 100,1 % que theme.css fuerza en la
     slide) acababa corriendo la slide activa 1,5 px: la foto vecina asomaba
     por el borde izquierdo. Pasandole el ancho exacto por `width`, slide,
     translate y contenedor coinciden: 0,00 px medido en
     docs/bench/swiper-subpixel-2.html. Va con el override
     `.product-card .swiper-slide { width: 100% !important }` del snippet
     becay-product-card-css; los dos juntos, o ninguno. */
  function cardWidth(el) {
    return el.getBoundingClientRect().width;
  }

  function syncWidth(entry) {
    if (!entry.swiper) return;
    var w = cardWidth(entry.el);
    if (!(w > 0)) return; /* oculta (display:none): se actualiza al mostrarse */
    if (w === entry.swiper.params.width) return;
    entry.swiper.params.width = w;
    entry.swiper.update();
  }

  /* La tarjeta cambia de ancho sin que cambie la ventana (selector de
     columnas de la coleccion, cajon de filtros): por eso ResizeObserver y no
     solo `resize`. */
  var ro = typeof ResizeObserver === 'function'
    ? new ResizeObserver(function (items) {
        items.forEach(function (item) {
          if (item.target.__bcyEntry) syncWidth(item.target.__bcyEntry);
        });
      })
    : null;

  function initCard(el) {
    if (el.__bcySwiper) return;
    /* Tarjeta con una sola slide: las secciones que sirven la tarjeta sin
       pase de fotos (solo principal + hover) no necesitan carrusel, y un
       Swiper con loop y una unica slide deja el track descuadrado. Sin
       inicializar, la tarjeta se ve exactamente igual: la slide ocupa el
       ancho completo por el CSS de Swiper, y los botones siguen ocultos. */
    if (slideCount(el) < 2) {
      el.__bcySwiper = true;
      return;
    }
    if (typeof window.Swiper !== 'function') {
      /* swiper.js aun no ha ejecutado (solo posible si su defer fallo o
         va lentisimo): reintenta en breve en vez de dejar la card muerta */
      setTimeout(function () {
        initCard(el);
      }, 500);
      return;
    }
    el.__bcySwiper = true;
    var entry = { el: el, removedSlide: null, swiper: null };
    try {
      var opts = {
        direction: 'horizontal',
        loop: true,
        allowTouchMove: true,
        pagination: {
          el: el.querySelector('.swiper-pagination'),
          clickable: true,
          dynamicBullets: true,
          enabled: false,
        },
        navigation: {
          nextEl: el.querySelector('.swiper-button-next'),
          prevEl: el.querySelector('.swiper-button-prev'),
        },
        scrollbar: {
          el: el.querySelector('.swiper-scrollbar'),
        },
        on: {
          init: function () {
            var buttons = el.querySelector('.swiper-buttons');
            if (buttons) buttons.style.display = 'block';
          },
        },
      };
      var w = cardWidth(el);
      if (w > 0) opts.width = w;
      entry.swiper = new window.Swiper(el, opts);
      if (isDesktop) removeSecondSlide(entry);
      cards.push(entry);
      el.__bcyEntry = entry;
      if (ro) ro.observe(el);
    } catch (e) {}
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (item) {
        if (item.isIntersecting) {
          io.unobserve(item.target);
          initCard(item.target);
        }
      });
    },
    { rootMargin: '300px' }
  );

  function scan() {
    document.querySelectorAll('.product-card .swiper').forEach(function (el) {
      if (!el.__bcyObserved) {
        el.__bcyObserved = true;
        io.observe(el);
      }
    });
  }

  window.addEventListener('resize', function () {
    if (!ro) cards.forEach(syncWidth); /* respaldo sin ResizeObserver */
    var nowDesktop = window.innerWidth >= 758;
    if (nowDesktop === isDesktop) return;
    isDesktop = nowDesktop;
    cards.forEach(function (entry) {
      if (isDesktop) {
        removeSecondSlide(entry);
      } else {
        restoreSecondSlide(entry);
      }
    });
  });

  /* Una sola pasada sobre el HTML servido: este script va con `defer`, asi
     que el documento ya esta parseado cuando corre. Nada de MutationObserver
     para las tarjetas inyectadas despues (ver cabecera). */
  scan();
})();